import { Injectable } from '@angular/core';
import { AuthService } from '../../../../../core';
import { isStatusEmAnalise } from '../../status';

/** Service que valida os acessos e execuções de funcionalidades de pedidos das campanhas */
@Injectable({
    providedIn: 'root'
})
export class CampanhaPedidoAuthGuardService {

    constructor(private authService: AuthService) { }

    /** Verifica se pode liberar os pedidos da campanha */
    canLiberarPedidos(idCampanha: number, statusCampanha: number, quantidadePedidosVendasNaoLiberados: number, quantidadePedidosBonificacoesNaoLiberados: number): boolean {
        // Se a campanha não possuir ID então não pode liberar seus pedidos
        if (idCampanha <= 0) {
            return false;
        }

        // Se a campanha não estiver em análise então não pode liberar seus pedidos
        if (!isStatusEmAnalise(statusCampanha)) {
            return false;
        }

        // Se o usuário não possuir permissão de liberar pedidos, então não pode liberar
        if (!this.authService.podeLiberarPedido()) {
            return false;
        }

        // Somente quando existir pedidos de vendas ou bonificação a serem liberados
        return quantidadePedidosVendasNaoLiberados > 0 || quantidadePedidosBonificacoesNaoLiberados > 0;
    }
}
